<template>
  <v-container class="fill-height addadvertiser" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-12">
         <template>
           <v-container>
             <v-row class="text-center">
               <v-col cols="12">
                 <div class="loader" v-if="loadingWizard"></div>
                 <!--@on-complete="onComplete"-->
                <form-wizard  @on-loading="setLoading" title ="DamnN" subtitle="Ads" >
                <tab-content title="Website"  :before-change="validatestepone">
                  <div style="margin:20px;">
                  <template>
                     <v-row justify="start">
                      <v-text-field v-model="adapp"  :rules="adappRules" style="display:none;" class="padding-top-0 padding-bottom-0" label=""></v-text-field>
                        <v-text-field v-model="adwebsiteslug" style="display:none;"   class="padding-top-0 padding-bottom-0" label=""></v-text-field>
                        <v-col class="text-left" cols="12" sm="12" md="12"> 
                          <h3>Select the website below that you want to advertise on.</h3>
                        </v-col>  
                      <v-row justify="start">
                        <template  v-for="(getwebsite) in websitelist">
                          <v-col :key="getwebsite.publisherId" class="text-left mr-6" cols="2" sm="2" md="2" v-if="getwebsite.websiteslug != 'pi3ck' && getwebsite.websiteslug != 'risk' && getwebsite.websiteslug != 'mynews24'  && getwebsite.websiteslug != ''"> 
                            <button v-if="getwebsite.websiteslug !='html' " 
                            v-bind:class="{ 'activewebsite': getwebsite.publisherId === activeId }" 
                            v-on:click="selectWeb(getwebsite.publisherId,getwebsite.websiteslug)"> 
                            <div  style="border-radius:2px; padding:2px;">
                               <v-avatar  :style="{ 'background-color': getwebsite.websitecolor, 'border-radius':'0' }" size="100%"  >
                                  <img style="width:100%;height:100%;" :src="adserverURL+'images/'+getwebsite.websitelogo">    
                               </v-avatar>
                            </div>
                           </button>
                         </v-col>
                       </template>
                     </v-row>
               </v-row>
              </template>
              </div>
            </tab-content>
            <tab-content title="Upload" :before-change="validatestepthird">
               <v-row>
                 <v-col cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                    <div><strong><span class="require">*</span> Business Name</strong></div>
                 </v-col>
                 <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                    <v-text-field v-model="adtitle"  :rules="adtitleRules" class="padding-top-0 padding-bottom-0" label="Business Name"></v-text-field>
                </v-col> 
               <v-col cols="6" sm="6" md="6" class="padding-top-0 padding-bottom-0">
                  <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                      
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="from_date"
                            label="Ad. Start Date"
                            hint="DD/MM//YYYY format"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            @blur="date = parseDate(from_date)"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fromdate"
                          no-title
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
               </v-col> 
 
<v-col cols="6" sm="6" md="6" class="padding-top-0 padding-bottom-0">
                  <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="to_date"
                            label="Ad. End Date"
                            hint="DD/MM//YYYY format"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            @blur="date = parseDate(to_date)"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="todate"
                          no-title
                          @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
               </v-col> 
              </v-row> 
                 <v-row>
                <v-col class="padding-top-0 padding-bottom-0">
                    <v-container class="padding-top-0 padding-bottom-0" fluid>
                       <v-radio-group   v-model="adtype"   row >
                        <template v-slot:label>
                        <div><strong>Ad Type </strong></div>
                        </template>
                        
                         <div v-for="(getzonelist) in websitezonelist" :key="getzonelist.zoneId" class="mr-5">
                          <input type="radio" v-if="getzonelist.type == 0" class="radiocls" id="Image" value="web" name="adtype"  @click="getadtype('web',getzonelist.type,getzonelist.zoneId,getzonelist.width,getzonelist.height)" v-model="adtype">
                          <label  class="radiolabelcls" v-if="getzonelist.type == 0" for="Image">Image </label>
                          
                          <input class="radiocls" v-if="getzonelist.type == 1" type="radio" id="Html" value="html" name="adtype" @click="getadtype('html',getzonelist.type,getzonelist.zoneId,getzonelist.width,getzonelist.height)" v-model="adtype">
                          <label  class="radiolabelcls" v-if="getzonelist.type == 1" for="Html">Html </label>
                          <template v-if="adwebsiteslug != 'sportrade'">
                            <input class="radiocls" type="radio" v-if="getzonelist.type == 6 " id="Video" value="video" name="adtype" @click="getadtype('html',getzonelist.type,getzonelist.zoneId,getzonelist.width,getzonelist.height)" v-model="adtype">
                            <label  class="radiolabelcls" v-if="getzonelist.type == 6" for="Video">Video </label>
                          </template>
                        </div>
                        </v-radio-group>
                    </v-container>
                </v-col>
              </v-row> 

              <!--- Adtype--->  
                 <v-row v-if="adtype =='web' && zoneType == 0">
                <v-col cols="12" sm="12" md="12" class="padding-top-0 text-left padding-bottom-0">
                 <div><strong><span class="require">*</span>Image</strong></div>
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                   <!--<v-file-input    accept="image/*" class="padding-top-0 padding-bottom-0"   label="File input"  ></v-file-input> -->
                   <v-row>
                      <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                   <v-btn  color="blue-grey" class="ma-2 white--text" @click="$refs.files.click()">
                                Upload<v-icon  right dark>mdi-cloud-upload</v-icon>
                              </v-btn>
                   </v-col>
                   <v-col cols="4" sm="4" md="4" class="padding-top-0 padding-bottom-0">
                        <v-avatar size="80px">
                     <!-- <img alt="Banner Image" :src="notimageimage" v-if="image === baseURL+'storage/1.1' || image === baseURL+'storage/.1'">
                       -->
                      <img alt="Banner Image" :src="image" v-if="image" >
                    </v-avatar>
                     </v-col>
                    <!-- No duration picker here either. It was still
                         appearing on the image step after the advertiser had
                         been on the video step (2026-11-03). An image ad
                         sends no duration, which is what every site other
                         than quizstar and droad already did, and the apps
                         fall back to their own default. -->
                   </v-row>
                  <input type="file" style="display: none" id="files"  ref="files"  v-on:change="handleFilesUpload()"/>
                </v-col>
                 <v-col cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                   <h5>You can upload a JPG,PNG </h5>
                 
                    <div v-for="(getzonelist) in websitezonelist" :key="getzonelist.zoneId">
                      <h5 v-if="getzonelist.zoneId == adzone">
                        <input style="display: none" type="text" id="imgwidth" v-bind:value="getzonelist.width" :name="imgwidth">
                        <input style="display: none" type="text" id="imgheight" v-bind:value="getzonelist.height" :name="imgheight">
                         Recommended Dimesion 
                         <span v-if="adwebsiteslug == 'myyaak'">
                           730 x 485
                         </span> 
                         <span v-else>{{getzonelist.width}} x {{getzonelist.height}}</span>
                         (Horizantal Image) 
                      </h5>
                      </div> 
                    <!--
                    <h5>Recommended Dimesion 400 x 304 (Horizantal Image) or 400 x 608 (Vertical Image)</h5>
                     -->
                 </v-col>
                 <hr>
               </v-row>
                <v-row v-if="adtype =='html' && zoneType == 1">
                <v-col cols="12" sm="12" md="12" class="padding-top-0 text-left padding-bottom-0">
                 <div><strong>Append and prepend settings</strong>
                </div>
                </v-col>
                 <v-col col="12">
                   <template>
                      <v-container fluid>
                        <v-row>
                          <v-col   cols="12"   md="12">
                            <v-textarea v-model="htmltemplate" label="Always the following HTML code to this banner" ></v-textarea>
                          </v-col>
                          <!--<v-col   cols="12"   md="12">
                            <v-textarea v-model="htmlprepend" label="Always prepend the following HTML code to this banner" ></v-textarea>
                          </v-col>
                          <v-col  cols="12"  md="12">
                            <v-textarea  v-model="htmlappend"  label="Always append the following HTML code to this banner"></v-textarea>
                          </v-col>    -->   
                        </v-row>
                      </v-container>
                    </template>
                 </v-col>  
               </v-row> 
                <v-row v-if="adtype =='video' && zoneType == 6">
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 text-left padding-bottom-0">
                 <div><strong> Upload Ad. Video </strong></div>
                </v-col>
                   <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                   <v-btn  color="blue-grey" class="ma-2 white--text" @click="$refs.videofiles.click()">
                                Upload<v-icon  right dark>mdi-cloud-upload</v-icon>
                              </v-btn>
                     <h5>You can upload a MP4</h5>
                     <!-- Every video ad runs 15 seconds, so there is nothing
                          to choose. The picker that used to sit beside this
                          offered 15/30/45/60 and is gone (2026-11-03); the
                          booking still sends `viewduration` - see
                          `videoViewDuration`. -->
                     <h5 class="grey--text">Video ads run for 15 seconds</h5>
                  <input type="file" style="display: none" id="videofiles"  ref="videofiles"  v-on:change="handleVideoFilesUpload()"/>
                    </v-col>
                    <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                       <div id="videocontent" v-html="videocontent"></div>
                   </v-col>

                 <div style="display:none">
                 <v-col cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Video Url</strong></div>
                </v-col>  
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-text-field v-model="advast_video_filename"   class="padding-top-0 padding-bottom-0" label="Video Url"></v-text-field>
                </v-col> 
                <v-col cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Video Type</strong></div>
                </v-col>
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="advast_video_type"  :items="advast_video_typearr" item-text="name" item-value="value"  label="" class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col> 
                     <v-col cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span>Video duration in seconds </strong></div>
                </v-col>
                <!--   <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-text-field v-model="advast_video_duration"   class="padding-top-0 padding-bottom-0" label="Video Duration"></v-text-field>
                </v-col> -->
                </div>
              </v-row>   
              <!----End Adtype----->

               <v-row>
                <v-col cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                 <div><strong><span class="require">*</span> Destination  Url</strong></div>
                </v-col>
                  <v-col cols="6" sm="6" md="6" style="display:none;" class="text-left padding-top-0 padding-bottom-0">
                 <div><strong>Image Tooltip Text</strong></div>
                </v-col>
               </v-row>
                 <v-row>
                  <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0">
                  <v-text-field v-model="destinationurl"  :rules="destinationurlRules" class="padding-top-0 padding-bottom-0" label="http://www.telstra.com"></v-text-field>
                </v-col>
                 <v-col cols="6" sm="6" md="6" style="display:none;" class="padding-top-0 padding-bottom-0">
                  <v-text-field v-model="imgtooltiptext" class="padding-top-0 padding-bottom-0" label="Text"></v-text-field>
                </v-col> 
               </v-row>
               <v-row v-if="adapp ==12">
                <v-col  cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                 <div><strong>Profile Image on myyaak</strong></div>
                </v-col>
               </v-row>
               <v-row v-if="adapp ==12">
                <v-col   cols="12"   md="12">
                  <v-btn  color="blue-grey" class="ma-2 white--text" @click="$refs.myyaaklogos.click()">
                                Upload<v-icon  right dark>mdi-cloud-upload</v-icon>
                              </v-btn>
                </v-col>
                <input type="file" style="display: none" id="myyaaklogos"  ref="myyaaklogos"  v-on:change="handleMyyaakUpload()"/>
               </v-row> 
                 <!--<v-row v-if="adapp ==1">
                 <input type="file"  id="files"  ref="files"  v-on:change="handleFilesUpload()"/>
                 </v-row>-->
                <v-row v-if="adapp ==12">
                <v-col  cols="12" sm="12" md="12" class="text-left padding-top-0 padding-bottom-0">
                 <div><strong>Text Above Banner</strong></div>
                </v-col>
               </v-row>
               <v-row v-if="adapp ==12">
                <v-col   cols="12"   md="12">
                  <v-textarea v-model="bannertext" label="Text Above Banner" ></v-textarea>
                </v-col>
               </v-row> 
            </tab-content>
              <tab-content title="Pricing" :before-change="validatestepsecond">
                <v-container>
                  <v-row dense>
                    <v-col cols="4" sm="4" md="4" class="padding-top-0 padding-bottom-0">
                      <v-text-field 
                          prepend-icon="mdi-currency-usd"
                          v-model="adplacement" @blur="getbudgetamount" type="number"
                          :min="minimumBudget"
                          :hint="'Minimum $' + minimumBudget" persistent-hint
                          class="padding-top-0 padding-bottom-0" label="Budget">
                      </v-text-field><!-- -->                    
                    </v-col>
                    <v-col cols="8" sm="8" md="8" class="pa-0 padding-bottom-0">
                       <div class="ml-0 text-left" style="margin-top:12px;"> </div>
                    </v-col> 
                    <v-col  cols="5" sm="5" md="5">
                       <!--
                      <v-row>
                          <v-chip class="ma-2 ml-0" color="primary" label outlined>
                             <v-icon left>mdi-video</v-icon> Duration {{view_duration}} Sec.
                          </v-chip>
                       </v-row>
                       <v-row >
                         <template >
                           <v-simple-table dark  blue loading >
                             <template v-slot:default>
                               <thead>
                                 <tr>
                                   <th class="text-center">Options </th>
                                   <th class="text-center">Cost</th>
                                   <th class="text-center">Time</th>
                                   <th class="text-center">Amount</th> 
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr :class="{ 'highlighted-row': viewclass === 5 }" @click="onRowClick(5)">
                                    <td>A</td>
                                    <td>5c </td>
                                    <td>15 Sec.</td>
                                    <td>0.05 Cent.</td> 
                                  </tr>
                                  <tr :class="{ 'highlighted-row': viewclass === 10 }" @click="onRowClick(10)">
                                    <td>B</td>
                                    <td>10c</td>
                                    <td>30 Sec.</td>
                                    <td>0.10 Cent.</td> 
                                  </tr>
                                  <tr :class="{ 'highlighted-row': viewclass === 15 }" @click="onRowClick(15)">
                                    <td>C</td>
                                    <td>15c</td>
                                    <td>45 Sec.</td>
                                    <td>0.15 Cent.</td> 
                                  </tr>
                                  <tr :class="{ 'highlighted-row': viewclass === 20 }" @click="onRowClick(20)">
                                    <td>D</td>
                                    <td>20c</td>
                                    <td>60 Sec.</td>
                                    <td>0.20 Cent.</td> 
                                  </tr>
                                </tbody>
                             </template>
                           </v-simple-table>
                          </template>
                        </v-row>
                      -->
                     </v-col>
                    </v-row>
                    <v-row class="pt-5">
                      <v-col  cols="12" sm="12" md="12" class="text-left">
                        <h4>= {{cal_totalamount_another}} Estimated people viewing your ad. </h4>
                       </v-col>
                    </v-row>
                  </v-container>
                </tab-content>
                <tab-content title="Maps" :before-change="validatestepfourth" >
               <v-row >
                          <v-col class="text-left" cols="12" sm="12" md="12"> 
                            <h3>Select the country or city that you would like to advertise in.</h3>
                        </v-col> 
              </v-row>
                   <v-row>  
                  <v-col  cols="12" sm="12" >   
                    <GoogleMapLoader 
                     v-if="showgooglemap == true"
                    :getcountrylist="countrieslist"
                    :getradiusarr.sync="mapsradiusarr"
                     :getlocationsarr ="locationsarr"
                     :getadwebsiteslug ="adwebsiteslug"
                     :apiKey="getapikey" style="width: 100%; height: 100%;margin-bottom:10px;" :mapConfig="mapConfig()">
                    </GoogleMapLoader>
                   </v-col> 
                    </v-row> 
                   
                
            </tab-content> 
            <tab-content title="Preview" v-if="showpositionsection == true" >
               <v-row>
                  <v-col cols="12" sm="12" v-if="mapsection">   
               <!---- Banner Postions Load Compoments----->
                <template> 
                  
                  <myyaak-template v-if="adwebsiteslug == 'myyaak'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                  :myyaaklogo="myyaaklogo"
                  :adtitle="adtitle"
                   ></myyaak-template>
                  </template>
                  <!-----End Load Compoments--------->
                  <!---- My news 24 Load Compoments----->
                  <template>
                  <mynews-template v-if="adwebsiteslug == 'mynews24'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></mynews-template>
                  </template>
                  <!-----End Load Compoments--------->
                   <!---- Myvoco Load Compoments----->
                  <template>
                  <myvoco-template v-if="adwebsiteslug == 'myvoco'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></myvoco-template>
                  </template>
                  <!-----End Load Compoments--------->
                    <!---- Damnntips Load Compoments----->
                  <template>
                  <damnntipsviewtemplate v-if="adwebsiteslug == 'damnntips'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></damnntipsviewtemplate>
                  </template>
                  <!-----End Load Compoments--------->
                  <!---- Risk Load Compoments----->
                  <template>
                  <risk-template v-if="adwebsiteslug == 'risk'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></risk-template>
                  </template>
                  <!-----End Load Compoments--------->
                  <!---- Pi3ck Load Compoments----->
                  <template>
                  <pi3ck-template v-if="adwebsiteslug == 'pi3ck'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></pi3ck-template>
                  </template>
                  <!-----End Load Compoments--------->
                  <!---- Sportstrade Load Compoments----->
                  <template>
                  <sportstrade-template v-if="adwebsiteslug == 'sportrade'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></sportstrade-template>
                  </template>
                  <!-----End Load Compoments--------->
                   <!---- Quizstar Load Compoments----->
                  <template>
                  <quizstar-template v-if="adwebsiteslug == 'quizstar'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></quizstar-template>
                  </template>
                  <!-----End Load Compoments--------->
                   <!---- Droad Load Compoments----->
                  <template>
                  <droad-template v-if="adwebsiteslug == 'droad'"
                  :bannerposition.sync="bannersection"
                  :bannercontentimage="bannercontentimage"
                  :bannercontenthtml="bannercontenthtml"
                  :bannercontent="bannercontent"
                  :bannerimage="logo"
                   ></droad-template>
                </template>
                <!-----End Banner Postions Load Compoments--------->                   </v-col> 
               </v-row>  
            </tab-content> 
            <tab-content title="Confirm" >
                <!---- Myyyaak Load Compoments----->
                <template>
                  <div class="mt-5 mb-5">
                    <div class="makebox">
                      <div class="inline">
                        <div>Estimated people viewing your ad :</div>
                        <div>{{ cal_totalamount_another }}</div>
                     </div>
                     <div class="inline">
                      <div>Ad Cost :</div>
                      <div>${{adplacement}}</div>
                   </div>
                     <div class="inline" v-if="showcreditbalance > 0">
                      <div>Credit :</div>
                      <div>${{ showcreditbalance }}</div>
                   </div>
                   <div class="inline" v-if="showcreditbalance > 0">
                    <div>Balance to pay :</div>
                    <div>${{ finalamounttopay }}</div>
                 </div>
                    </div>
                    <div><!--v-if="adplacement > showcreditbalance"-->
                      <v-btn class="mt-4"  id="paypal-button" v-if="!paymentcompleted" ></v-btn> 
                    </div>
                  </div>
                </template>
                <!-----End Load Compoments--------->
            </tab-content>
              <!--
               <el-button type="primary"  v-if="isdisabled"  class="wizard-btn" slot="finish" style="display:nopne;background-color: rgb(231, 76, 60); border-color: rgb(231, 76, 60); color: white;">Finish</el-button>
                -->
                <BlockUI v-if="showblock" :message="msg" :url="loadingimgurl"></BlockUI>
                  
                    <!--<el-button type="primary" :disabled="hidefinishbutton"  class="wizard-btn" slot="finish" style="background-color: rgb(231, 76, 60); border-color: rgb(231, 76, 60); color: white;">Finish</el-button>-->
                    <template slot="footer" slot-scope="props">
                      <div class="wizard-footer-left">
                        <wizard-button  v-if="props.activeTabIndex > 0 " @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button>
                       </div>
                       <div class="wizard-footer-right">
                         <template v-if="isAdmin == 1">
                          <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Next</wizard-button>
                          <wizard-button v-else-if="props.isLastStep" @click.native="onComplete"  class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Finish' : 'Next'}}</wizard-button>
                         </template>
                         <template v-else>
                          <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Next</wizard-button>
                          <wizard-button v-else-if="props.isLastStep && !hidefinishbutton" @click.native="onComplete"  class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Finish' : 'Next'}}</wizard-button>
                         </template>
                       </div>
               </template>
          </form-wizard>
             <div class="errormsg" v-if="errormgexist">{{errormg}}</div>
      </v-col>

    </v-row>
  </v-container>
</template>

  </v-card>
      </v-col>
    </v-row>
     <!---Dialog-->  
     
     <v-dialog v-model="showModalSize" max-width="350" persistent>
      <v-card>
         <v-card-text>
          <div class="text-center pt-5"><h2>Attention! </h2></div>
          <div class="pt-5 pb-5 pl-5 pr-5">
             You have not uploaded the correct {{ correctdimension}} required to best display your ad, your ad may appear pixelated to users, please upload the correct 
            </div>   
        </v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="showModalSize = false">Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="modal" max-width="320">
      <v-card>
        <v-card-title class="headline" >
       <h3 class="msggreen" >Payment Successfull! </h3>
          </v-card-title>
         <v-card-text>Click on finish to save your ad</v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="modal = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog v-model="savingdata"  width="400">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            <div class="mx-auto">Please Wait ....</div>
          </v-card-title>
          <v-card-text>
          </v-card-text>
        </v-card>
      </v-dialog>  
    <!----End Dilog-----> 
  </v-container>
</template>
<script>
//import draggable from "vuedraggable";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {FormWizard, TabContent} from 'vue-form-wizard'
import MyyaakTemplate from './Myyaaktemplate.vue'
import RiskTemplate from './Risktemplate.vue'
import Pi3ckTemplate from './Pi3cktemplate.vue'
import SportstradeTemplate from './Sportstradetemplate.vue'
import QuizstarTemplate from './Quizstartemplate.vue'
import MynewsTemplate from './Mynewstemplate.vue'
import DroadTemplate from './Droadtemplate.vue'
import MyvocoTemplate from './Myvocotemplate.vue'
import Damnntipsviewtemplate from './Damnntipsviewtemplate.vue'
//import BannerpositionTemplate from '../components/Bannerpositiontemplate.vue'
import GoogleMapLoader from "../components/GoogleMapLoader.vue";
import MapSettings from "../constants/mapSettings.js";
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { mapGetters } from "vuex";
import {loadScript} from "vue-plugin-load-script";
import BlockUI from 'vue-blockui'
import loadingImage from '../assets/loading.gif'


Vue.use(BlockUI)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
//var adserverURL ="http://local.adserver.com/www/";
var damnnUrl = process.env.VUE_APP_BASEAPI;
  export default {
    name: 'Adform',
    components: {
          FormWizard,
          TabContent,
          MyyaakTemplate,
          RiskTemplate,
          Pi3ckTemplate ,
          SportstradeTemplate,
          QuizstarTemplate,
          GoogleMapLoader,
          /*BannerpositionTemplate,*/
          MyvocoTemplate,
          MynewsTemplate,
          DroadTemplate,
          Damnntipsviewtemplate
        },
    data: vm => ({
      items: [
        { action: '15 Sec.', title: '1 View',  },
        { action: '30 Sec.', title: '2 Views', },
        { action: '45 Sec.', title: '3 Views', },
        { action: '60 Sec.', title: '4 Views', }
      ],
      model: {
        adapp: '',
      }, 
      rules: {
        firstName: [{
          adapp: true,
          message: 'Select Ap. is required',
          trigger: 'blur'
        }],
      },
     // getapikey :"AIzaSyCuVAzIeYJnldNWLmrRpRcMQmyB0N2Tnv4",
     //AIzaSyCL46KsABqTW25DYtyToj0a8FrKpwMti8w
      getapikey : "AIzaSyBrp5gAvIHno5lKOjUI9XJh70pDeoi3ovY",
      
      savingform : false,
      cal_view : 0,
      cal_centamount : 0,
      cal_totalamount: 0,
      budgetamount:0,
      mapsradiusarr:[
                       {
                         latitude: -37.549999,
                         longitude: 143.850006,
                         radius: 500,
                       },
                    ],
      modal:false,
      paymentcompleted:false,
      transactionid:'',
      showgooglemap:false,
      showpositionsection:true,
      deliveryrulesarr: [
        {text:"Geo - Country / City",value:"City"},
        {text:"Geo - Connection Type",value:"ConnectionType"},
        {text:"Geo - Continent",value:"Continent"},
        {text:"Geo - Country",value:"Country"},
        {text:"Geo - Latlong",value:"Latlong"},
      //  {text:"Geo - Organisation",value:"Organisation"}
      ], 
       continentarr: [
        {text:"Africa",value:"AF"},
        {text:"Antartica",value:"AQ"},
        {text:"Asia",value:"AS"},
        {text:"Caribbean",value:"CA"},
        {text:"Europe",value:"EU"},
        {text:"North America",value:"NA"},
        {text:"Australia/Oceania",value:"OC"},
        {text:"South America",value:"SA"}
      ],
      continent:"",
      countryarr: [
        {text:"India",value:"IN"},
        {text:"Australia",value:"AU"},
        {text:"United States of America",value:"US"}
      ], 
      connectiontypearr: [
        {text:"Unknown",value:"unknown"},
        {text:"Dial-up",value:"dialup"},
        {text:"Broadband",value:"cabledsl"},
         {text:"Corporate",value:"corporate"},
        {text:"Cellular",value:"cellular"} 
      ],
      deliveryruleshtml:[],
      locationsarr:[],
      connectiontype:"",
      deliveryrule : "",
      ccountry:[],
      ccity :"",
      delcountry:"",
      comparison_1:"",
      logical:[],  
      lat1:"",      
      lat2:"",      
      long1:"",
      long2:"",  
      blockRemoval: true,   
      rightcontent: "",  
      leftcontent : "",   
      errormgexist : false,
      errormg: "",      
      activeId : 0,      
      websitelist : [],
      adzone:0 ,     
      websitezonelist : [],  
      htmltemplate:"",
      column: null,  
      row: null,  
      from_date: '', //vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      fromdate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),  
      todate:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),  
      to_date: '',//vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)), 
      file: '',
      files:[],  
      videofiles:[],   
      videofile:"", 
      image:"",  
      adplacement :'', 
      cal_budget : 5,
      htmlprepend :"", 
      htmlappend : "",
      myyaaklogo:"",
      myyaaklogos:[],
      bannertext :"",
      adtitle:"",      
      adtype: "",      
      // bannersection: "left",
      bannerrightsection:"right",      
      logo: require("@/assets/logo.png"),
      adhere: require("@/assets/506.jpg"),
      list1: [{ name: require("@/assets/logo.png") }],
      advast_video_duration:"",      
      bannercontent:"",      //items: adplacementarr,
      imgtooltiptext : "",      
      destinationurl: "",      
      adapp:0,
      adappRules: [v => !!v || 'Select Ad. App.',
                   //   v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                    ],
      adtitleRules: [v => !!v || 'Enter Name',
                   //   v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                    ],  
      destinationurlRules: [v => !!v || 'Add your website',
                   //   v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                    ],                 
                             
      loadingWizard: false ,      
      adserverURL : process.env.VUE_APP_ADSERVER_WEB_BASEURL,
      adbannerid:"",      
      bannercontentimage:"",      
      bannercontenthtml:"",
      adwebsiteslug:"risk",      
      bannercode:"",
      imgwidth:"",      
      imgheight:"",      
      bannersection:"leftcontent",
      advast_video_filename:"",      
      advast_video_type:"",      
      vast_video_delivery:"",
      zoneType:"",      
      adplacementslist:[],
      videocontent:"",
      mapsection:false,
      location:null,
      gettingLocation: false,
      errorStr:null,
      countrieslist:[],
      placetype:"country",
      mapcountryarr:[],
      countrycity:"",
      cloudfronturl :"https://d1jxx34eyyrl5j.cloudfront.net/",
      allowvideofiletypes : ["video/mp4","video/x-mp4","video/flv","video/x-flv","video/webm"],
      
      // What every video ad runs for. One number, not a choice - the
      // 15/30/45/60 picker was removed on 2026-11-03.
      videoViewDuration: 15,
      /// The least an advertiser may book, in dollars.
      minimumBudget: 10,
      viewdurationcountarr:[15,30,45,60],
      viewdurationarr:[1,2,3,4],
      viewamountarr:[0.05,0.10,0.15,0.20],
      viewamount:0,
      videouploaderror:"",
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      savingdata:false,
      isdisabled:true,
      msg: 'Saving Data,Please wait...',
      showblock:false,
      loadingimgurl:loadingImage,
      viewclass:0,
      view_duration:'',
      comparisonarr_country_city:[
        {text:"is equal to",value:"=="},
        {text:"is different from",value:"!="},
        {text:"Contains",value:"=~"},
        {text:"Does not contain",value:"!~"},
        {text:"Regex match",value:"=x"},
        {text:"Regex does not match",value:"!x"}  
      ],
      comparisonarr_generalarr:[
       {text:"Is any of",value:"=~"},
        {text:"Is not any of",value:"!~"},
      ],
       comparisonarr_latlongarr:[
       {text:"Is within",value:"=="},
        {text:"Is not within",value:"!="},
      ],
      logicalarr:[
       {text:"Or",value:"or"},
       {text:"And",value:"and"},
      ],
      desserts: [
                  { name: '1', time: '15 Sec.', amount: '0.05 Cent.', },
                  { name: '2', time: '30 Sec.', amount: '0.10 Cent.', },
                  { name: '3', time: '45 Sec.', amount: '0.15 Cent',  },
                  { name: '4', time: '60 Sec.', amount: '0.20 Cent.', },
                ],
      headers: [
                  { text: 'View', align: 'start', sortable: false, value: 'name', },
                  { text: 'Time', value: 'time' },
                  { text: 'Amount', value: 'amount' },
               ],
      /*
      durationarr: [
        {name:"15 Sec.",value:15},
        {name:"30 Sec.",value:30},
        {name:"45 Sec.",value:45},
        {name:"60 Sec.",value:60}, 
      ],  
      */
      advast_video_typearr: [
        {name:"MP4",value:"video/x-mp4"},
        {name:"FLV",value:"video/x-flv"},
        {name:"WEBM",value:"video/webm"}
      ],     
      hidefinishbutton:true,
      cal_totalamount_another:0,
      showModalSize:false,
      correctdimension:''
    }),
   mounted() 
   {
     this.getDamanBalance();
     //console.log(this.$store.getters.isAdmin);
     
     this.getAdserverWebsiteList();
     this.getbanner();
     this.getadplacements();
     //this.getcountries();
     this.pay();
   },
   beforeMount() 
   {
     setTimeout(() => {  this.checkbalanceamount();  }, 100);
   },
   computed:{
    durationarr() {
      if(this.adwebsiteslug == 'myyaak')
      {
        return [
          {name:"15 Sec.",value:15},
          {name:"30 Sec.",value:30},
        ];
      }  
      else
       {
        return [
          {name:"15 Sec.",value:15},
          {name:"30 Sec.",value:30},
          {name:"45 Sec.",value:45},
          {name:"60 Sec.",value:60}, 
        ];
       } 
     
    },
    finalamounttopay(){
       //showcreditbalance  
       //adplacement
       let lastamount = 0;
       if(this.adplacement > this.showcreditbalance)
         lastamount = this.adplacement - this.showcreditbalance;
       else
         lastamount = this.showcreditbalance - this.adplacement;

       return lastamount.toFixed(2);
    },
    isAdmin(){
      if(this.$store.getters.isAdmin) {
       return 1;
     }
      else{
        return 0;
      }
    },
     ...mapGetters(
         {
           showamount : 'showamount',
           showkelamount : 'showkelamount',
           showdaminamount : 'showdaminamount',
           showcreditbalance: 'getCreditBalance'  
         }),
          baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            },
            computedDateFormatted () {
        return this.formatDate(this.fromdate)
      },
     },
      watch: {
      // **Choosing Video fixes the duration at 15 seconds.**
      //
      // There is no picker any more, so the value has to come from
      // somewhere; setting it here means the rest of the form - the
      // pricing maths reads `view_duration` - sees the real number rather
      // than a blank. Switching back to Image clears it, because an image
      // ad books no duration at all.
      adtype (val) {
        this.view_duration = val == 'video' ? this.videoViewDuration : '';
      },
      fromdate (val) {
        this.from_date = this.formatDate(val)
      },
       todate (val) {
        this.to_date = this.formatDate(val)
      },
      view_duration(){
             this.cal_budget = this.adplacement;
      
      for( var vdc = 0; vdc < this.viewdurationcountarr.length; vdc++ ){
         if(this.adtype == "video")
        {
           if(this.advast_video_duration <= this.viewdurationcountarr[vdc])
              {
                this.cal_view = this.viewdurationarr[vdc];
                this.cal_centamount =  this.viewamountarr[vdc];
                break;
              }
        }
        else{
              if(this.view_duration == this.viewdurationcountarr[vdc])
              {
                this.cal_view = this.viewdurationarr[vdc];
                 this.cal_centamount =  this.viewamountarr[vdc];
              }
        } 
        }
       // this.cal_totalamount = Math.round(this.cal_budget / (this.cal_view * this.cal_centamount));//  this.budgetamount;
        if(this.view_duration == 15)
          this.viewclass = 5;
        else if(this.view_duration == 30)
          this.viewclass = 10; 
        else if(this.view_duration == 45)
          this.viewclass = 15; 
        else if(this.view_duration == 60)
          this.viewclass = 20; 

          
      }
    },
    methods: { 
      pay() {
var mythis = this;
         //********** PAYPAL CODE ****************
           loadScript("https://www.paypalobjects.com/api/checkout.js").then(() => 
             {
             
               window.paypal.Button.render({
                   env: 'sandbox',
                 client: {
                    sandbox: 'AYSQ-B3COkyHGMWTWkyrfWtl8tPdxEBI0GejO4tfbmPX3JbT_zv-lshM3EmQXiHoDzvd964pQGz1Sjlo'
                    /* production: 'AUxJGrr53OY24x1KlUwTHy4rkPvhW_Srkli1rmnRjfHyDTa00ZEgphHVJ0wkdVnWxA43KeMrPCVS39re' */
                 },
                 locale: 'en_US',
                 style: {
                          size: 'small',
                          color: 'gold',
                          shape: 'pill',
                          tagline: 'false'
                        },
                 commit: true,

                 payment: function(resolve, reject) {
                   console.log(resolve, reject);
                  let returnUrl = "https://admin.sporttrade.online/faq";
                  let amount = mythis.finalamounttopay;

                  //********* Check Validate ***************

                     if (mythis.adplacement === "") {
                        mythis.stripeErr = "Please budget amount";
                          return false;
                       }else{
                         mythis.stripeErr = "";
                       }
                  //****************************************
                   return new Promise((resolve, reject) => {
                  Vue.axios.post(damnnUrl+'adserverCredit', {
                    return_url: returnUrl,
                    amount:amount,
                    app_type:"adserver"
                }, {
                        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('damn_token') }
                    })
                    .then(res => {
                      //console.log(res.data);
                        localStorage.setItem('reference_id', res.data.paypal_intent_id.reference_id);
                        mythis.transactionid = res.data.paypal_intent_id.reference_id;
                        resolve(res.data.paypal_intent_id.paypal_intent_id)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
            },
            
            onAuthorize: function(data) {
                  return new Promise((resolve, reject) => 
                  {
                Vue.axios.post(damnnUrl+'execute-payment-centralize-adserver',  {
                    payer_id: data.payerID,
                    payment_id: data.paymentID,
                    reference_id:localStorage.getItem('reference_id'),
                    description:"Banner creating charge"
                }, {
                        headers: { 'Authorization': 'Bearer ' +  localStorage.getItem('damn_token') }
                    })
                    .then(res => {
                      localStorage.removeItem('reference_id');
                      localStorage.removeItem('price');
                      //mythis.closedeposit();
                     // mythis.$store.dispatch('retrieveInbankKelBalance');
                      //mythis.$store.dispatch("retrieveInbankKelBalance");
                      mythis.modal = true;
                      mythis.paymentcompleted = true;
                      mythis.hidefinishbutton = false;
                        resolve(res)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
            }
          }, '#paypal-button'); 


             });
         //***********END PAYPAL CODE *************
   
    },
       onRowClick(cal){
         this.viewclass = cal;
         this.view_duration = cal;
         if(this.cal_budget != '')
         {
          let value = parseFloat(this.viewclass/100);
          this.cal_totalamount = Math.round(this.cal_budget / value);
          
         }
       },
       getbudgetamount(event)
      {
         
        this.cal_budget = event.target.value;
        const randomNumber = Math.floor(Math.random() * 2) + 1;
        
        if(this.adtype == 'video')
        {
          const value = parseFloat(this.viewclass/100);
          this.cal_totalamount = Math.round(this.cal_budget / value);
          const mycal = Math.round(this.cal_totalamount * 0.05);
          
          if(randomNumber == 1)
          {
            let newnumber = 0;
            if(randomNumber == 1)
              newnumber = 2;
            else
              newnumber = 1;

            this.cal_totalamount_another =  this.cal_totalamount + mycal + newnumber;    
          }
          else
          {
            let newnumber = 0;
            if(randomNumber == 1)
              newnumber = 2;
            else
              newnumber = 1;
           
              
            this.cal_totalamount_another =  mycal - newnumber;   
            if(this.cal_totalamount_another <= 0)
            {
              this.cal_totalamount_another = this.cal_totalamount + 1
            }
          }
        }
        else if(this.adtype == 'web')
        {
          //const value = parseFloat(this.viewclass/100);
          //this.cal_totalamount = Math.round(this.cal_budget / 100);
          this.cal_totalamount = this.cal_budget*50;
          const mycal = Math.round(this.cal_totalamount * 0.05);
          console.log(randomNumber);
          if(randomNumber == 1)
          {
            let newnumber = 0;
            if(randomNumber == 1)
              newnumber = 2;
            else
              newnumber = 1;

            this.cal_totalamount_another =  this.cal_totalamount + mycal + newnumber    
          }
          else
          {
            let newnumber = 0;
            if(randomNumber == 1)
              newnumber = 2;
            else
              newnumber = 1;

              this.cal_totalamount_another = this.cal_totalamount + mycal - newnumber;   
            if(this.cal_totalamount_another <= 0)
            {
              this.cal_totalamount_another = this.cal_totalamount + 1
            }
          }
          console.log(this.cal_totalamount);
        }
      },
       checkbalanceamount()
      {
       
        if(Math.round(this.$store.getters.showamount) == 0.10 )
          {
              this.$router.push({ name: "topup" });
          }
      },
      
       formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
     //async getS3VideoUrl()
      async getS3VideoUrl()
      {
         localStorage.setItem('Fileupload_check', "");
        let formData = new FormData();
        var getvideofilename = "";  
        for( var vi = 0; vi < this.videofiles.length; vi++ ){
          let videofile = this.videofiles[vi];
           getvideofilename = this.videofiles[vi].name; 
           formData.append('videofile', videofile);
        }
        
         formData.append('advast_video_duration', "");
         formData.append('videofilename', getvideofilename);
      var Fileupload_check = "";
     await   this.$store.dispatch("videoupload",formData, {
        })
        .then(response => {
         this.advast_video_filename = this.cloudfronturl+response.data[0].video_url;
         this.advast_video_type = response.data[0].mime_type;
         this.advast_video_duration = response.data[0].video_duration;
         Fileupload_check = "Yes";
         })
        .catch(error => {
           console.log("Video File Error");
           Fileupload_check = "No";
           console.log(error.response.data.message);
         Fileupload_check =  error.response.data.message;
         localStorage.setItem('Fileupload_check', Fileupload_check);
        });
      
        return localStorage.getItem('Fileupload_check');
      },
     async  addbanner_sync()
      {
         try {
            var response = "vs"
            if(this.adtype=="video")
            {
               response = await this.getS3VideoUrl();
            }

        console.log(response);
        if(response =="Yes")
        {
          console.log(this.advast_video_filename);
          console.log(this.advast_video_type);
          console.log(this.advast_video_duration);
          
          console.log("Add Banner");
        }else{
            console.log("Not Video Banner");
        }
        
      } catch (ex) {
        console.log(ex);
      }
         
      },
       mapConfig() {
      MapSettings.center = this.mapCenter();
      return MapSettings;
    },
    mapCenter() {
      return {  lat: -37.549999, lng: 143.850006 };
    },
      selectdelivery()
      {
       this.deliveryruleshtml.push(
        {
         deliveryrule : this.deliveryrule,
         logical : null,
         comparison: null,
         country_countrydata:null,
         country_citydata:null,
         connectiontypedata:null,
         continentdata:null,
         countrydata:null,
         latone:null,
         lattwo:null,
         langone:null,
         langtwo:null,
         address:null
        } 
       
       );
      },
      removeLine (lineId) {
          //if (!this.blockRemoval) {
            this.deliveryruleshtml.splice(lineId, 1)
         // }
        },
          getadplacements(){
             this.$store.dispatch("quizstaradplacements",{
              })
              .then(response => {
                console.log(response.data);
                this.adplacementslist = response.data;
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Website Ad Placements error");
                console.log(error);
              });
      } ,
       getcountries(){
             this.$store.dispatch("damnnbankcountrieslist",{
              })
              .then(response => {
             //   console.log(response.data);
                this.countrieslist = response.data;
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Website Ad Countries error");
                console.log(error);
              });
      } ,
      setLoading: function(value) {
       this.loadingWizard = value
      },
      validatestepfourth : function(){
          this.mapsection = true;
          
         if (this.locationsarr.length == 0) {
               this.errormgexist = true;
               this.errormg = "Please select location";
               return false;
         }else{
             this.errormgexist = false;
               this.errormg = "";
            return true;
         }
        
      },
      validatestepone: function(){   
          //******************************************** */
              for (var key of Object.keys(this.websitezonelist)) {
                  if(this.websitezonelist[key].zoneId == this.adzone)
                  {
                    this.zoneType = this.websitezonelist[key].type;
                  }
                  
                }

                
         //************************************************* */     
           if (this.adapp == "") {
               this.errormgexist = true;
               this.errormg = "Please select website";
               return false;
         }else{
             this.errormgexist = false;
               this.errormg = "";
            return true;
         }
      },  //validatestepsecond  validatestepthird  validatestepfourth
      validatestepsecondold: function(){   
            if (this.adzone == "") {
               this.errormgexist = true;
               this.errormg = "Please select zone";
               return false;
         }else{
            this.errormgexist = false;
            this.errormg = "";
            return true;
         }
      },  
      validatestepsecond: function(){    
          this.showgooglemap = true;
            if (this.adplacement == "") 
            {
               this.errormgexist = true;
               this.errormg = "Please add your budget";
               return false;
           }
           // **A floor, not a format check.** The field is `type="number"`,
           // so the browser keeps letters out, but it happily took 0 or 1 -
           // and a dollar of budget buys an ad nobody sees. Checked here
           // rather than on the field so the step cannot be passed by
           // leaving the box without blurring it (2026-11-03).
           else if (isNaN(parseFloat(this.adplacement)) ||
                    parseFloat(this.adplacement) < this.minimumBudget)
           {
               this.errormgexist = true;
               this.errormg = "Minimum budget is $" + this.minimumBudget;
               return false;
           }
          //  else if(this.view_duration == '')
          //  {
          //      this.errormgexist = true;
          //      this.errormg = "Please choose duration";
          //      return false;
          //  }
           else
           {
            this.errormgexist = false;
            this.errormg = "";
            return true;
           }
      }, 
     async  validatestepthird(){      
          this.showgooglemap = false;
            if (this.adtitle == "") {
               this.errormgexist = true;
               this.errormg = "Please enter banner title";
               return false;
          }
          else  if (this.from_date == "") {
               this.errormgexist = true;
               this.errormg = "Please select start date";
               return false;
         }      
         else  if (this.to_date == "") {
               this.errormgexist = true;
               this.errormg = "Please select end date";
               return false;
         }      
          else  if (this.adtype == "") {
               this.errormgexist = true;
               this.errormg = "Please select adtype";
               return false;
         }else if (this.adtype == "web" && this.image =="") 
               {
               this.errormgexist = true;
               this.errormg = "Please select image";
               return false;
               }
         else if (this.adtype == "html" && this.htmltemplate =="") 
               {
               this.errormgexist = true;
               this.errormg = "Please enter html code";
               return false;
               }
               else if (
                         this.adtype === "video" && 
                        (this.adwebsiteslug === "quizstar" || this.adwebsiteslug == "droad" || this.adwebsiteslug == "myyaak") && 
                         this.view_duration == ''
                      ) 
               {
             
               this.errormgexist = true;
               this.errormg = "Please select duration";
               return false;
               }
               /*
          else if (this.adtype == "video" && this.advast_video_filename !="") 
               {
             
                      if(this.adtype=="video")
                      {
                        if(this.videofiles.length > 0)
                        {
                          var  response = "";// await this.getS3VideoUrl();

                            if(response != "")
                            {
                                this.$alert(response,"Upload Video","error"); 
                                return false;
                            }else{
                              return true;
                            }
                        }else{
                          return true;
                        }  
                      }
          }  
          */    
         else  if(this.destinationurl =="") {
               this.errormgexist = true;
               this.errormg = "Please enter destination url";
               return false;
         }
         else{
          // this.files.length
            this.errormgexist = false;
            this.errormg = "";
          //   document.getElementById("bannercontent").innerHTML ="";
            if(this.adtype =="html")
            {
            this.image = "";
            this.bannercontentimage = false;
            this.bannercontenthtml = true;
            this.bannercontent = this.htmltemplate;
           // document.getElementById("bannercontenthtml").innerHTML = this.htmltemplate;
            }

            if(this.adtype =="web")
            {
               this.bannercontenthtml = false;
               this.bannercontentimage = true;
               this.logo = this.image;
               this.bannercontent='<img class="list-item" width = "100%" height = "100%" alt="Avatar" src="'+this.image+'" >'
           // document.getElementById("bannercontent").innerHTML = '<img class="list-item"  alt="Avatar" :src="'+this.logo+'" >';
            }

              if(this.adtype =="video")
            {
            this.image = "";
            this.bannercontentimage = false;
            this.bannercontenthtml = true;
            var videohtml = '<video width = "100%" height = "100%" controls ><source src="'+this.advast_video_filename+'" type ="video/mp4"></video>';
            this.bannercontent = videohtml;
            
           // document.getElementById("bannercontenthtml").innerHTML = this.htmltemplate;
            }
            if(this.adwebsiteslug =="myyaak")
            {
             this.bannerposition = "leftcontent";
            }
             this.showgooglemap = true;
             
            return true;
         }
      }, 
      onComplete: function(){
      this.$confirm("Are you sure you want to create this ads ?").then(() => {
            this.showblock=true;    
            this.addbanner();  
          });  
     },
     getbanner(){
      //  this.selectWeb(1);
      var banner_id = this.$route.params.id;
       if(banner_id !="" && banner_id !=undefined)
      {  
       this.$store
        .dispatch("quizstarbannerdetails", {bannerid : banner_id})
        .then(response => {
         
         if(response.status =="success")
         { 
          this.adtitle = response.data.bannertitle;
          this.activeId    = ''+ response.data.websiteid+'';   
          this.adzone      = ''+ response.data.zoneid+''; 
          this.adplacement = response.data.price;
          this.adapp = response.data.websiteid;
          this.adwebsiteslug = response.data.websiteslug;
          this.bannertext = response.data.bannertext;
          

          this.cal_budget = this.adplacement;
          this.cal_view = response.data.viewduration;
          this.view_duration = response.data.viewduration;
          this.cal_centamount = response.data.amount;
          this.cal_totalamount = response.data.bannerviews;

            switch(this.adwebsiteslug)
            {  
              case "risk":
                this.showpositionsection = false; 
              break; 
              case "pi3ck":
                this.showpositionsection = false;
              break; 
              case "quizstar":
                this.showpositionsection = true;
              break;
               case "droad":
                this.showpositionsection = false;
              break;
              default:
                this.showpositionsection = true;
              break;  
            } 

          this.getzonelist(this.activeId);
          //console.log(this.activeId);
          this.fromdate = response.data.startdate;
          this.todate = response.data.enddate;
          this.adtype = response.data.adtype;
          this.htmltemplate = response.data.htmltemplate;
          this.image = this.adserverURL+"/images/"+response.data.bannerimage; 
          this.logo = this.adserverURL+"/images/"+response.data.bannerimage; 
          this.destinationurl = response.data.desitnationurl;
          this.imgtooltiptext = response.data.imagetooltip; 
          this.adbannerid = response.data.bannerid; 
          this.bannersection = response.data.bannersection; 

          this.advast_video_filename = process.env.VUE_APP_S3_URL+response.data.videourl;
        
          if(this.advast_video_filename !="")
          {
             this.zoneType = 6;
              var videohtml = '<video width = "100%" height = "100%" controls ><source src="'+this.advast_video_filename+'" type ="video/mp4"></video>';
            this.videocontent = videohtml;
          }
          this.advast_video_type = response.data.videotype;
          this.advast_video_duration = response.data.videoduration;

          this.imgwidth = response.data.bannerwidth;
          this.imgheight = response.data.bannerheight;
        
         // this.locationsarr = [];
      
          for (var key of Object.keys(response.data.acls)) {
               this.locationsarr.push(
                            {
                            latone: parseFloat(response.data.acls[key].latone),
                            lattwo: parseFloat(response.data.acls[key].lattwo),
                            langone: parseFloat(response.data.acls[key].langone), 
                            langtwo: parseFloat(response.data.acls[key].langtwo),
                            radius: parseFloat(response.data.acls[key].radius),
                            countrycode: response.data.acls[key].countrycode,
                            countryname: response.data.acls[key].countryname,
                            address: response.data.acls[key].address
                            } 
                          );
           }
         }else{
          this.$alert("You are unauthorize user.","Unauthorize","fail");
         }
        // console.log("locationsarr");
        // console.log(this.locationsarr);
        // console.log("locationsarr end");
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Banner details error");
          console.log(error);
        });
      }
     },
   async addbanner() 
   {
      let formData = new FormData();
      var getfilename = "";  
      var getmyyaklogosfilename="";
      for( var i = 0; i < this.files.length; i++ )
      {
         let file = this.files[i];
         getfilename = this.files[i].name;  
         formData.append('aImage', file);
      }
      for( var j = 0; j < this.myyaaklogos.length; j++ )
      {
         let file = this.myyaaklogos[j];
         getmyyaklogosfilename = this.myyaaklogos[j].name;  
         formData.append('myyaaklogo', file);
      }
      /* var getvideofilename = "";  
        for( var vi = 0; vi < this.videofiles.length; vi++ ){
          let videofile = this.videofiles[vi];
           getvideofilename = this.videofiles[vi].name; 
           formData.append('videofile', videofile);
        }
        formData.append('videofilename', getvideofilename);
      */
      formData.append('transactionid',this.transactionid);
      if(this.adtype=="video")
      { 
         var getvideofilename = "";    
         var getvideotype ="";  
         for( var vi = 0; vi < this.videofiles.length; vi++ )
         {
            let videofile = this.videofiles[vi];
            getvideofilename = this.videofiles[vi].name;
            getvideotype = this.videofiles[vi].type;
            formData.append('videofile', videofile);
         }
         formData.append('videofilename', getvideofilename);
         formData.append('compressvideofilename', "compress-"+getvideofilename);
         this.advast_video_filename = process.env.VUE_APP_S3_BUCKET_URL+"compress-"+getvideofilename;

         if(getvideotype == "video/mp4")
         {
           getvideotype = "video/x-mp4"; 
         }
         else if(getvideotype == "video/flv")
         {
           getvideotype = "video/x-flv";  
         }
         this.advast_video_type = getvideotype;
        // formData.append('advast_video_type', this.advast_video_type);a
      }
      formData.append('filename', getfilename);
      if(this.isAdmin == 1)
      {
         formData.append('campaignId',  7);
         formData.append('bannerby',  'admin');
      } 
      else
      {
         formData.append('campaignId',  6);
         formData.append('bannerby',  'me');
      }
        formData.append('bannerName', this.adtitle);
        formData.append('BannerType', this.adtype);
        formData.append('myyaakprofilelogo', getmyyaklogosfilename);
        formData.append('logical', this.logical);

      if(this.adtype=="video")
      {
        formData.append('storageType', "html");
      }
      else
      {
        formData.append('storageType', this.adtype);
      }
        formData.append('htmlTemplate', "'"+this.htmltemplate+"'");
        formData.append('url', this.destinationurl);
        formData.append('alt', this.imgtooltiptext);
            
       //********  Not For Adserver */    
       formData.append('adapp', this.adapp);
       formData.append('websiteslug', this.adwebsiteslug);
       formData.append('adposition', this.adposition);
       formData.append('adzone', this.adzone);
       formData.append('adplacement', this.adplacement);
       formData.append('fromdate', this.fromdate);
       formData.append('todate', this.todate);
       formData.append('htmlprepend', "");
       formData.append('htmlappend', "");
       formData.append('bannertext', this.bannertext);
       formData.append('advast_video_filename', this.advast_video_filename);
       formData.append('advast_video_type', this.advast_video_type);
       formData.append('advast_video_duration', this.advast_video_duration);
       // A video ad is always 15 seconds, so it has no picker any more -
       // see the note by the MP4 upload. The field still goes up, because
       // both apps read `oxtw_banners.viewduration` for how long to show an
       // ad; leaving it blank would break them, not simplify them.
       formData.append(
         'viewduration',
         this.adtype == 'video' ? this.videoViewDuration : this.view_duration
       );
       formData.append('bannerviews',this.cal_totalamount);
       formData.append('amount', this.cal_view * this.cal_centamount);
       var banner_id = this.adbannerid;
       
       if(this.adtype =="web")
      { 
         this.imgwidth = document.getElementById("imgwidth").value;
         this.imgheight = document.getElementById("imgheight").value;
         formData.append('imgwidth', this.imgwidth);
         formData.append('imgheight', this.imgheight);
      }

      if(this.adtype =="html")
      { 
         formData.append('width', this.imgwidth);
         formData.append('height', this.imgheight);
      }
       
      if(this.mapsradiusarr.length > 0)
      { 
        for (var imap= 0; imap < this.mapsradiusarr.length;imap++) 
        {
            formData.append('deliveryrules['+imap+']["deliveryrule"]',this.mapsradiusarr[imap].countrycode); 
            formData.append('deliveryrules['+imap+']["logical"]',"or"); 
            formData.append('deliveryrules['+imap+']["comparison"]',"=="); 
            formData.append('deliveryrules['+imap+']["country_countrydata"]',""); 
            formData.append('deliveryrules['+imap+']["country_citydata"]',""); 
            formData.append('deliveryrules['+imap+']["connectiontypedata"]',""); 
            formData.append('deliveryrules['+imap+']["continentdata"]',""); 
            formData.append('deliveryrules['+imap+']["countrydata"]',this.mapsradiusarr[imap].countrycode); 
            formData.append('deliveryrules['+imap+']["countryname"]',this.mapsradiusarr[imap].countryname); 
            // The two longitudes used to be posted the wrong way round -
            // `langone` carrying `langtwo` and back. Harmless only because
            // both hold the circle's centre and are therefore equal; it
            // would have silently mirrored the geofence the day they
            // differed.
            formData.append('deliveryrules['+imap+']["latone"]',this.mapsradiusarr[imap].latone); 
            formData.append('deliveryrules['+imap+']["langone"]',this.mapsradiusarr[imap].langone); 
            formData.append('deliveryrules['+imap+']["lattwo"]',this.mapsradiusarr[imap].lattwo); 
            formData.append('deliveryrules['+imap+']["langtwo"]',this.mapsradiusarr[imap].langtwo); 
            formData.append('deliveryrules['+imap+']["radius"]',this.mapsradiusarr[imap].radius); 
            formData.append('deliveryrules['+imap+']["address"]',this.mapsradiusarr[imap].address); 
            
            /*                     
            formData.append('deliveryrules['+imap+']["deliveryrule"]',"Country"); 
            formData.append('deliveryrules['+imap+']["logical"]',"and"); 
            formData.append('deliveryrules['+imap+']["comparison"]',"=~"); 
            formData.append('deliveryrules['+imap+']["country_countrydata"]',""); 
            formData.append('deliveryrules['+imap+']["country_citydata"]',""); 
            formData.append('deliveryrules['+imap+']["connectiontypedata"]',""); 
            formData.append('deliveryrules['+imap+']["continentdata"]',""); 
            formData.append('deliveryrules['+imap+']["countrydata"]',this.mapsradiusarr[imap].countrycode); 
            formData.append('deliveryrules['+imap+']["latone"]',""); 
            formData.append('deliveryrules['+imap+']["langone"]',""); 
            formData.append('deliveryrules['+imap+']["lattwo"]',""); 
            formData.append('deliveryrules['+imap+']["langtwo"]',""); 
            formData.append('deliveryrules['+imap+']["radius"]',""); 
             */  
        }   
     } 
 
     if(banner_id =="")
     {
      this.$store.dispatch("adserveraddbanner", formData).then(response => 
        {
          //this.debitBalance(this.transactionid,response.bannerId);
          formData.append('price', this.adplacement);
          formData.append('bannerid', response.bannerId);
          formData.append('bannerimage', getfilename);
          formData.append('bannereditid',"" );
          this.adserverlinkbannerzone(this.adzone,response.bannerId);
          var getzoneid = this.adzone;
          var getbannercodetype = "adframe";
          // Get Banner Code/ 
          this.$store.dispatch("adserverbannercode",{zoneid:getzoneid ,bannercodetype:getbannercodetype }, { }).then(response => 
          {
            this.bannercode = response.invocation_code;
            localStorage.setItem('bannercode', response.invocation_code);
          }).catch(error => {
                  console.log("Website List error");
                  console.log(error);
        });
          //***************** Banner targeting *****************  */ 
             // this.addbannertargeting(response.bannerId);  
          //******************************************************* */
          var bannercode = localStorage.getItem('bannercode');
          var banner_code  = bannercode.replace(/http/gi, "https"); // Online
          formData.append("bannercode",banner_code); // Online
          //End/ 
          formData.append("bannerheight",this.imgheight);
          formData.append("bannerwidth",this.imgwidth);
          formData.append("bannersection",this.bannersection); 
          if(this.adtype=="video")
          {
             formData.append('storageType', "video");
          }
          this.savequizstarbanner(formData);
        })
        .catch(error => {
          console.log("Add Banner error");
          console.log(error);
        }); 
      }
      else
      {
        formData.append('bannerId', parseInt(banner_id));
        formData.append('editbanner', "Y");
    
         this.$store.dispatch("adservereditbanner", formData).then(response => 
         {
            //******************************************** */
             /* var adplacementprice = "";
                for (var key of Object.keys(this.adplacementslist)) 
                {
                  if(this.adplacementslist[key].price == this.adplacement)
                  {
                    adplacementprice = this.adplacementslist[key].price;
                  }
                }
              */
         //************************************************* */     
         //  this.debitBalance(this.adplacement * 100);
          formData.append('bannerid', banner_id);
          formData.append('bannerimage', getfilename);
          formData.append('bannereditid', response.bannerId);

         var getzoneid = this.adzone;
         var getbannercodetype = "adframe";
       
       //***************  Get Banner Code ********** */ 
        this.$store.dispatch("adserverbannercode",{zoneid:getzoneid,bannercodetype:getbannercodetype }, { }).then(response => 
        {
           this.bannercode = response.invocation_code;
           localStorage.setItem('bannercode', response.invocation_code);
        }).catch(error => 
        {
          console.log("Website List error");
          console.log(error);
        });
          
        var bannercode = localStorage.getItem('bannercode');
        var banner_code  = bannercode.replace(/http/gi, "https"); // Online
        formData.append("bannercode",banner_code); // Online
        //************************************************** */  
        formData.append("bannerheight",this.imgheight);
        formData.append("bannerwidth",this.imgwidth);
        formData.append("bannersection",this.bannersection); 

        if(this.adtype=="video")
        {
          formData.append('storageType', "video");
        }
        this.savequizstarbanner(formData);
         //***************** Banner targeting ******************/ 
         // this.addbannertargeting(response.bannerId);  
         //********************************************************/
         // console.log(response);
         })
          .catch(error => {
                // TODO: handle incorrect login
                console.log("Edit Banner error");
                console.log(error);
            });
          }
    },
    addbannertargeting(getbannerid)
    {
         if(this.deliveryruleshtml.length > 0)
      { 
         var deliveryrules = []; 
       
     for (var key of Object.keys(this.deliveryruleshtml)) 
     {
               
                deliveryrules =[];
              var deliveryruletype =  this.deliveryruleshtml[key].deliveryrule;
              switch(deliveryruletype)
              {
                 case "City":
                     deliveryrules["logical"] = this.deliveryruleshtml[key].logical;
                     deliveryrules["type"] = "deliveryLimitations:Geo:"+deliveryruletype+"";
                     deliveryrules["comparison"] = this.deliveryruleshtml[key].comparison;
                     deliveryrules["data"] = this.deliveryruleshtml[key].country_countrydata+"|"+this.deliveryruleshtml[key].country_citydata;
                 break;
                 case "ConnectionType":
                     deliveryrules["logical"] = this.deliveryruleshtml[key].logical;
                     deliveryrules["type"] = "deliveryLimitations:Geo:"+deliveryruletype+"";
                     deliveryrules["comparison"] = this.deliveryruleshtml[key].comparison;
                     deliveryrules["data"] = this.deliveryruleshtml[key].connectiontypedata;
                 break;  
                 case "Continent":
                     deliveryrules["logical"] = this.deliveryruleshtml[key].logical;
                     deliveryrules["type"] = "deliveryLimitations:Geo:"+deliveryruletype+"";
                     deliveryrules["comparison"] = this.deliveryruleshtml[key].comparison;
                     deliveryrules["data"] = JSON.parse(JSON.stringify(this.deliveryruleshtml[key].connectiontypedata));
            
                 break; 
                 case "Country":
                     deliveryrules["logical"] = this.deliveryruleshtml[key].logical;
                     deliveryrules["type"] = "deliveryLimitations:Geo:"+deliveryruletype+"";
                     deliveryrules["comparison"] = this.deliveryruleshtml[key].comparison;
                     deliveryrules["data"] = this.deliveryruleshtml[key].connectiontypedata;
            
                 break;  
                 case "Latlong":
                    deliveryrules["logical"] = this.deliveryruleshtml[key].logical;
                     deliveryrules["type"] = "deliveryLimitations:Geo:"+deliveryruletype+"";
                     deliveryrules["comparison"] = this.deliveryruleshtml[key].comparison;
                     deliveryrules["data"] = this.deliveryruleshtml[key].connectiontypedata;
            
                 break;  
              }

                this.$store.dispatch("adserverbannertargetting",{bannerid:getbannerid
                    ,targetcode:deliveryrules
                    }, {
                    })
                    .then(response => {
                      console.log(response);
                    })
                    .catch(error => {
                      console.log("Banner Geo Targetting List error");
                      console.log(error);
                    });
       }  // End For Loop    
            console.log(deliveryrules);
       
      }  // End If
    },
    debitBalance(transactionid,adserverbannerId) 
    {
      
       this.$store.dispatch("updateTransaction",{
            transactionid:transactionid,
            bannerid:adserverbannerId
           // gametype:game_type
          
          }).then(() => {
            //this.showinbankbalance = this.$store.getters.showamount;
            //this.showkelamount = this.$store.getters.showkelamount;

         });
     },
     savequizstarbanner(formData)
     {
       var bannerid = formData.get("bannereditid");
      //***************  End Banner Code******* */
       this.$store.dispatch("quizstaraddbanner", formData).then(() => 
       {
         // console.log(response);
          if(bannerid =="")
          {
            this.$store.dispatch("retrieveDammnbankBalance");
            this.$alert("Banner has been added successfully.","Banner","success");
          }
          else
          {
            this.$alert("Banner has been updated successfully.","Banner","success");
          }  
          this.$router.push({ name: "adlist" });
      }).catch(error => {
          // TODO: handle incorrect login
          console.log("Quizstar Add Banner error");
          console.log(error);
        });
     },
     adserverlinkbannerzone(zoneid,bannerid) {
       this.$store.dispatch("adserverlinkbannerzone",{
            zoneid:zoneid,
            bannerid:bannerid 
          }).then(() => {
            //this.showinbankbalance = this.$store.getters.showamount;
            //this.showkelamount = this.$store.getters.showkelamount;

         });
     },
     getAdserverWebsiteList() {
      this.$store.dispatch("retrieveAdserverWebsitesList", {
        })
        .then(response => {
          this.websitelist = response;
          this.websitelist = [
  ...this.websitelist.filter(site => site.websiteslug !== 'droad'),
  ...this.websitelist.filter(site => site.websiteslug === 'droad')
];
         // console.log(this.websitelist);
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Website List error");
          console.log(error);
        });
    },
      selectWeb: function (id,websiteslug) {              
        this.activeId = id;
        this.adapp = id;
        this.adtype = '';
        this.adwebsiteslug = websiteslug;
      
        switch(websiteslug)
        {  
          case "risk":
            this.showpositionsection = false;
          break; 
          case "pi3ck":
            this.showpositionsection = false;
          break; 
          case "quizstar":
            this.showpositionsection = true;
          break;
          case "droad":
            this.showpositionsection = false;
          break;
          default:
             this.showpositionsection = true;
          break;  
        } 

           this.getzonelist(id);
        },
      selectZone: function (value) {              
        //alert(value);
       // console.log(value);
        //console.log(this.websitezonelist);
         for (var key of Object.keys(this.websitezonelist)) {
           if(this.websitezonelist[key].zoneId == value)
           {
             //console.log(this.websitezonelist[key].zoneId + " -> " + this.websitezonelist[key].type);
             this.zoneType = this.websitezonelist[key].type;
             //   this.zoneType = 0    Banner, Button or Rectangle
             //   this.zoneType = 1    Interstitial or Floating DHTML
             //   this.zoneType = 6    Inline Video ad

             if(this.zoneType == 0)
             {
              this.adtype ="web";
             }else if(this.zoneType == 1)
             {
               this.adtype ="html";
             }else if(this.zoneType == 6)
             {
               this.adtype ="video"; 
             } 
           }
          
        }


        },  
        
     checkMoveOLD: function(evt){
       console.log("checkMove");
       console.log(evt.to.id);
       this.bannersection = evt.to.id;
    //return (evt.draggedContext.element.name!=='apple');
    },            
     handleChange() {     //  Here Start Draggble Functions
    //  console.log(this);
     // console.log("Chnage");
    },
    inputChanged(value) {
      this.activeNames = value;
    },
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    }, //  Here End Draggble Functions
     getadtype(getadtype,getzonetype,getzoneid,getwidth,getheight)
     {
       this.bannercontent = "";
       this.zoneType = getzonetype;
       this.adzone = getzoneid;
       this.imgwidth = getwidth;
       this.imgheight = getheight;
       if(getadtype =="html")
       {
         this.image = "";
         this.bannercontent = this.htmltemplate;
       }

       if(getadtype =="web")
       {
         this.bannercontent = '<img class="list-item"  alt="Avatar" :src="'+ this.logo +'" >';
       }
        //bannercontent-left
        
       
        //console.log(getadtype);
     },
     handleFilesUpload() 
     {
      let uploadedFiles = this.$refs.files.files;
      
      for (var i = 0; i < uploadedFiles.length; i++) 
      {
        let file = uploadedFiles[i];
        this.files.push(file);
        this.image = URL.createObjectURL(file);
        this.logo = URL.createObjectURL(file);
        
        let checkwidth =  Number(this.websitezonelist[0].width);
        let checkheight = Number(this.websitezonelist[0].height);
        if(this.adwebsiteslug == "myyaak")
        {
          checkwidth  = 730; 
          checkheight = 485;
        } 

        if (file && file.type.startsWith('image/')) 
        {
          let reader = new FileReader();
          reader.onload = (event) => {
                let img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                  let width = img.width;
                  let height = img.height;
                  
                  let requiredWidth = checkwidth; 
                  let requiredHeight = checkheight;

                  if (width !== requiredWidth || height !== requiredHeight) {
                    this.showModalSize = true;
                    this.correctdimension = requiredWidth+" X "+requiredHeight+" px";
                  }
                };
              };
              reader.readAsDataURL(file);
         }
  }
},
      
      handleMyyaakUpload(){
        
        let uploadedFiles = this.$refs.myyaaklogos.files;
         
        for( var i = 0; i < uploadedFiles.length; i++ ){
          this.myyaaklogos.push( uploadedFiles[i] );
        //  console.log(URL.createObjectURL(uploadedFiles[i]));
         // this.$store.state.bannerimage = URL.createObjectURL(uploadedFiles[i]);
          this.myyaaklogo = URL.createObjectURL(uploadedFiles[i]);
          
        }
      },
      /// Puts the video step back to empty after a rejected file.
      ///
      /// Without this the preview, the filename and the measured duration
      /// all survive the alert, so the advertiser sees a rejected video
      /// sitting there looking accepted - and `videofiles` still carries it
      /// into the booking.
      clearVideoUpload(){
        this.videofiles = [];
        this.videocontent = "";
        this.advast_video_filename = "";
        this.advast_video_duration = 0;
        if (this.$refs.videofiles) { this.$refs.videofiles.value = ""; }
      },
       handleVideoFilesUpload(){
        let uploadedFiles = this.$refs.videofiles.files;
      
         var video = document.createElement('video');
                  video.src = URL.createObjectURL(uploadedFiles[0]);
                      video.preload = 'metadata';
                      var getthis = this;
                      // **The length is checked here and nowhere else.**
                      //
                      // The duration only exists once the browser has read
                      // the file's metadata, which lands after the type and
                      // size checks below have already run - so a long video
                      // cannot be caught down there. Until 2026-11-03 it was
                      // read and then ignored, and a minute-long file was
                      // accepted as happily as a short one.
                      //
                      // The upload itself goes to the bank's shared
                      // `uploads3File`, which other apps use too, so the
                      // rule cannot live there. This is the only gate.
                      video.onloadedmetadata = function() {
                      window.URL.revokeObjectURL(video.src);
                       var duration = video.duration;
                       getthis.advast_video_duration = Math.round(duration);

                       if (getthis.advast_video_duration > getthis.videoViewDuration) {
                         getthis.clearVideoUpload();
                         getthis.$alert(
                           "That video is " + getthis.advast_video_duration +
                           " seconds. Video ads must be " +
                           getthis.videoViewDuration + " seconds or less.",
                           "Video too long",
                           "Error"
                         );
                       }
                      }
            
        for( var i = 0; i < uploadedFiles.length; i++ ){
          this.videofiles.push( uploadedFiles[i]);
        //   console.log(URL.createObjectURL(uploadedFiles[i]));
           this.advast_video_filename = URL.createObjectURL(uploadedFiles[i]);
           var file_extension = uploadedFiles[i].type;
        
          var exists  =   this.allowvideofiletypes.includes(file_extension);
          if(exists == false)
            {
              this.$alert("You can upload mp4,flv,webm","Error");
                return;
            }
 



           if (uploadedFiles[i].size > ((1024 * 1024)*5)) {
                  this.$alert("File too big ( > 5MB)","Upload Video File","Error");
                return;
              } 
            var videohtml = '<video width = "100%" height = "100%" controls ><source src="'+URL.createObjectURL(uploadedFiles[i])+'" type ="'+file_extension+'"></video>';
            this.videocontent = videohtml;
        }
      },
          getDamanBalance() {
          this.$store.dispatch("retrieveDammnbankBalance").then(() => {
           });
      },  
        getInbankBalance() {
          this.$store.dispatch("retrieveInbankKelBalance").then(() => {
         });
      },
        getzonelist(getwebsiteid)
          {
              //alert(getwebsiteid);
              this.$store.dispatch("retrieveWebsiteZoneList",{websiteid : getwebsiteid}, {
              })
              .then(response => {
                this.websitezonelist = response.data;
                //console.log("Testing");
                //console.log(this.websitezonelist);
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Website Zone List error");
                console.log(error);
              });
          },
    }
  }
</script>
<style >
.disabled{color:#111 !important;}
.wizard-title{font-weight: bold !important;}
.category{color:#111 !important;}
.stepTitle{color:#111 !important;}
.websiteradio .v-label{line-height: 40px !important; font-size:20px !important;}
/*.v-avatar{border-radius: 0% !important;}*/
</style>
<style>  
.stats-container  header {height: 35px !important;}
.stats-container  .v-toolbar__content {height: 35px !important;}
.stats-container   .v-toolbar__title{font-size: 1.0em;}
.theme--dark.v-data-table{width:100%;}
.loading-icon img{width:50px;height:50px;}
</style>
<style scoped>
.makebox {
  border: 1px solid #000;
  width: 37%;
  margin: auto;
  border-radius: 8px;
  padding: 15px;
}
.inline {
  display: flex;
}
.inline div {
  flex: 0 0 84%;
}
.inline div:first-child{
  color: #000;
  font-weight: bold;
  text-align: left;
}
.inline div:last-child{
  text-align: left;
}
tr.highlighted-row {
    background: cornflowerblue;
}
.row {
  margin-left: 0px;
}
#addadvertiser .v-card__subtitle, .v-card__text, .v-card__title {
    padding: 4px !important;}
.padding-top-0{padding-top: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.require{color: red; font-size: 15px;}
.radiolabelcls{padding-left:10px !important;}
.radiocls{padding-left:10px !important;}
.radiolabelcls{padding-left: 10px !important;padding-right: 5px !important;margin-top: -3px;
}
.errorshow{color:red;font-size: 15px;margin:0 auto;}
.draggable-list {  color: #fff;  border: 1px solid;  height: 150px;}
.list-item {  width:100%;  height: 100%;  position: relative;}
.h5{background-color: hsl(240deg 19% 82%);font-size:18px;}
.header-content{width:100%;height: 71px;}
.left-content{height: 100%; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.activewebsiteold{    width: 168px;    height: 167px;
    border-radius: 85px;    padding: 23px;    border: 1px solid red;
    background-color: #fff;
}
.activewebsite{    width: 140px;    
    border-radius: 5px;    padding: 5px;    border: 1px solid red;
    background-color: #fff;
}
/*.vue-form-wizard {background-color: #e1dada !important;} */
.draggablecontent{background-size: 100% 100%;}
.loader,
.loader:after {  border-radius: 50%;  width: 10em;  height: 10em;}
.errormsg{font-size:20px; color: red;}
.loader {
  margin: 60px auto;font-size: 10px; position: relative;  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);  border-left: 1.1em solid #e74c3c;
  -webkit-transform: translateZ(0);  -ms-transform: translateZ(0);  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {  0% {    -webkit-transform: rotate(0deg);    transform: rotate(0deg);
  }
  100% {-webkit-transform: rotate(360deg); transform: rotate(360deg); }
}
@keyframes load8 { 0% {-webkit-transform: rotate(0deg); transform: rotate(0deg);  }
  100% {-webkit-transform: rotate(360deg); transform: rotate(360deg);  }
}
#bannercontentimage{width:100%;height:100%;position: relative;}
#bannercontenthtml{width:100%;height:100%;position: relative;color:#000; background-color: #fff;}
.avatarcls{width: 100%;height: 100%; }
.postionsection{width: 100%;height: 100%;}
tr.highlighted-row {
    background: cornflowerblue;
}
</style>